import { AuditOutlined, CloudSyncOutlined, LockOutlined, SafetyCertificateOutlined, TeamOutlined } from '@ant-design/icons';

import Page from '../../Components/Page/Page';
import { TextService } from '../../Services/TextService';
import { Card, Checks, Crumbs, CtaBanner, Hero, SectionHead, Split, useScrollTop } from '../Start2/Marketing2';
import '../Start2/Start2.css';

// SEO article for /gdpr-och-sakerhet, built from the shared Start2 marketing components.
// Leaves out claims we could not verify: EU-only storage, two-factor auth for admins, consent logging.
const MemberSystemSafety = () => {
  const GetText = TextService.GetText;
  useScrollTop();

  const principles = [
    "Samla in uppgifter för tydliga och berättigade ändamål",
    "Begränsa mängden data till det som är relevant",
    "Skydda uppgifterna från obehörig åtkomst",
    "Informera medlemmar om hur deras data används",
    "Radera eller rätta uppgifter vid begäran",
  ];

  return <Page className='start2' pageTitle={GetText("PageTitle_Safety_GDPR")} metaDescription="GDPR-anpassat medlemsregister. Vi tar datasäkerhet och personuppgifter på allvar – säker autentisering och krypterad lagring.">

    <Hero
      crumb={<Crumbs current="GDPR och säkerhet" />}
      title="Trygg hantering av personuppgifter – GDPR och säkerhet i OneFront360"
      lead={<>Ett medlemssystem byggt med <strong>GDPR och informationssäkerhet</strong> i fokus – så att du kan känna dig trygg med hur medlemmarnas data behandlas.</>}
      image={require('../../Images/Articles/sakert-medlemsregister.png')}
      imageAlt="Illustration av GDPR och säkerhet i OneFront360"
    />

    <section className="s2-section s2-bg-soft">
      <div className="s2-container">
        <SectionHead
          title="GDPR – vad innebär det för föreningar?"
          text="Dataskyddsförordningen gäller alla organisationer som behandlar personuppgifter – även ideella föreningar. Som föreningsansvarig har du ett juridiskt ansvar att:" />
        <div className="s2-cards">
          {principles.map((p, i) => (
            <div className="s2-card" key={p}>
              <span className="s2-numbered">{i + 1}</span>
              <p>{p}</p>
            </div>
          ))}
          <div className="s2-card s2-tint-green">
            <h3>OneFront360 hjälper dig</h3>
            <p>…att följa principerna genom inbyggda funktioner för dataskydd och transparens.</p>
          </div>
        </div>
      </div>
    </section>

    <section className="s2-section">
      <div className="s2-container">
        <Split eyebrow="GDPR i praktiken" title="Så hjälper OneFront360 dig att följa GDPR" visual={
          <div className="s2-logo-panel s2-tint-blue"><span className="s2-big-icon"><SafetyCertificateOutlined /></span></div>
        }>
          <p>Du får verktyg som gör det enkelt att hantera GDPR – och en trygg, transparent hantering som stärker medlemmarnas förtroende.</p>
          <Checks items={[
            "Exportera personuppgifter vid begäran",
            "Radera medlemmar enligt rätten till radering",
            "Logg över skickad e-post och SMS",
            "Medlemmar kan själva se och uppdatera sina uppgifter",
          ]} />
        </Split>
      </div>
    </section>

    <section className="s2-section s2-bg-soft">
      <div className="s2-container">
        <SectionHead
          title="Säkerhet i OneFront360 – så skyddas dina data"
          text="Systemet är byggt med modern teknik och säkerhetsrutiner som skyddar både medlemmarnas personuppgifter och föreningens interna information." />
        <div className="s2-cards s2-cards-2">
          <Card icon={<LockOutlined />} title="Kryptering"><p>Krypterad datalagring och överföring.</p></Card>
          <Card icon={<TeamOutlined />} title="Behörighetsstyrning"><p>Kontroll över vem som ser vad – fullständig, redigerings- eller läsbehörighet.</p></Card>
          <Card icon={<AuditOutlined />} title="Spårbarhet"><p>Automatiska loggar och historik över ändringar.</p></Card>
          <Card icon={<CloudSyncOutlined />} title="Uppdateringar"><p>Regelbundna säkerhetsuppdateringar.</p></Card>
        </div>
      </div>
    </section>

    <CtaBanner />
  </Page>
};

export default MemberSystemSafety;
